// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"0e24e8a2","678":"51c18e43","787":"ff97d96a"}[chunkId] + ".chunk.js";
};